/**
 * Web half of the app-level bindings the package needs. NOT synced — the app
 * repo ships its own version pointing at its paths. Everything else in the
 * package (bar `polygon_views.tsx`) is byte-identical across both repos, so
 * route new cross-repo import differences through here rather than letting
 * them land in a shared file.
 *
 * Keep this free of React components: `useThunkSelector` imports it, so
 * anything reachable from here lands in every bundle that touches a thunk
 * selector.
 */
export { asError } from '@app/packages/asError/asError'
export { noop } from '@app/utils/noop'
export { useStackContext } from '@app/packages/StackContext/StackContext'
